import request from '@/api/request'
/**
* 描述：获取项目资料
* 接口管理员：崔北超
* 参数： 
{
    projectId: '',          // 项目ID(有项目时再传，没有为空)
    tableName: ''   // 表名
}
*/
export const getProjectFileData = function (data) {
    return request({
        url: 'busProjectFile/getFiles',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述: 项目资料 - 修改项目资料是否有此内容
 * 接口管理员: 郑志会
 */
export const updateProjectFileNodeState = function (data) {
    return request({
        url: '/busProjectFile/updateProjectFileNodeState',
        method: 'post',
        data
    })
}